module.exports = __webpack_public_path__ + "static/img/no_list_1.5f939f8c.png";